/**
 * useGoalAddition — Handles the add-goal dialog state and submission.
 */
import { useState } from "react";
import { Goal } from "@/types/todo";
import { usePoints } from "@/hooks/usePoints";

export const useGoalAddition = (addGoal: (goal: Goal) => void) => {
  const [hasAddedCustomGoal, setHasAddedCustomGoal] = useState(false);
  const { addGoalPoints } = usePoints();

  const handleExampleGoalClick = (goal: Goal) => {
    if (!goal.isExample) return;

    const selectedGoal = { ...goal, isExample: false, todos: [] };
    addGoal(selectedGoal);
    setHasAddedCustomGoal(true);
    // Award points if goal has an ID
    if (selectedGoal.id) {
      addGoalPoints(selectedGoal.id);
    }
  };

  return {
    hasAddedCustomGoal,
    handleExampleGoalClick,
  };
};
